<template>
  <v-content pa-0>
    <Header></Header>
    <div
        style="position: relative;display: flex;justify-content: center;align-items: center"
        :style="$vuetify.breakpoint.mdAndUp ? {'padding-top': '88px'}:{}"
    >
      <v-img
          style="width: 100%"
          max-height="500px"
          :src="$vuetify.breakpoint.smAndDown ? http + developerBanner.mobile_img : http + developerBanner.desktop_img"
      ></v-img>
    </div>
    <loading :active.sync="isLoading"></loading>
    <template>
        <v-layout justify-start>
          <v-flex class="headTab" mt-20 >
            <v-simple-table
                fixed-header
                height="100vh"
                class="mb-5 "
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th width="5%" class="text-center headTab table-bg-color" style="color: #FF4F23">
                    <p style="font-size: 18px" class="my-3">{{$t('developer.no')}}</p>
                  </th>
                  <th width="35%" class="text-center headTab table-bg-color" style="color: #FF4F23">
                    <p style="font-size: 18px" class="my-3">{{$t('developer.data_sheet')}}</p>
                  </th>
                  <th width="45%"  class="text-center headTab table-bg-color">
                    <p style="font-size: 18px" class="my-3">{{$t('developer.description')}}</p>
                  </th>
                  <th width="15%"  class="text-center headTab table-bg-color">
                    <p style="font-size: 18px" class="my-3">ช่องทางการเรียกใช้ API</p>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item,i) in devdata"
                    :key="i"
                    class="text-left"
                >
                  <td class="text-center">
                        <a class="link-data-dev-hover dev-data-text text-center" style="font-size: 18px"  @click="hrefTo(`/developerDetail/${item.id}`)">{{i+1}}</a>
                  </td>
                  <td class="px-0 mx-0 text-xl-left text-lg-left text-md-left text-sm-left text-center">
                     <span v-if="language == 'th'">
                        <a class="link-data-dev-hover dev-data-text " style="font-size: 18px"  @click="hrefTo(`/developerDetail/${item.id}`)">{{item.title || item.name_th}}</a>
                     </span>
                     <span v-if="language == 'en'">
                       <a class="link-data-dev-hover dev-data-text" style="font-size: 18px" @click="hrefTo(`/developerDetail/${item.id}`)">{{item.title || item.name_en}}</a>
                    </span>
                  </td>
                  <td class="px-0 mx-0 text-xl-left text-lg-left text-md-left text-sm-left text-center">
                    <p class="link-data-dev dev-data-text mb-0  py-5">
                     <span v-if="language == 'th'">
                        <a class="link-data-dev dev-data-text px-sm-0 " style="font-size: 18px" @click="hrefTo(`/developerDetail/${item.id}`)" >{{item.notes || item.description_th}}</a>
                     </span>
                      <span v-if="language == 'en'">
                       <a class="link-data-dev dev-data-text px-sm-0 " style="font-size: 18px" @click="hrefTo(`/developerDetail/${item.id}`)" >{{item.notes || item.description_en}}</a>
                    </span>
                    </p>
                  </td>
                  <td class="text-center">
                    <p class="link-data-dev dev-data-text mb-0  py-5">
                    <span v-if="language == 'th'">
                        <a style="font-size: 18px" v-if="item.name" class="txt-link-cea" :href="domainCkan + '/dataset/' + item.name" target="_blank">ข้อมูลเพิ่มเติม</a>
                        <a style="font-size: 18px" v-else class="txt-link-disable" >ข้อมูลเพิ่มเติม</a>
                    </span>
                      <span v-if="language == 'en'">
                      <a style="font-size: 18px" v-if="item.name" class="txt-link-cea" :href="domainCkan + '/dataset/' + item.name" target="_blank">more details</a>
                      <a style="font-size: 18px" v-else class="txt-link-disable" >more details</a>
                    </span>
                    </p>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
    </template>

    <Footer></Footer>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Service from "../services";
import Loading from 'vue-loading-overlay';
import { mapActions, mapState } from "vuex";
import {domain, domainCkan} from "../services/Constants";

export default {
  name: "developer",
  components: {
    Header,
    Footer,
    Loading
  },
  data: () => ({
    loaded: false,
    http: domain,
    isLoading: false,
    domainCkan: domainCkan,
  }),
  computed: {
    ...mapState({
      language: state => state.locale.language,
      devdata:(state) => state.DevData.dataDev,
      developerBanner: state => state.banner.developerBanner,
      industries: function (state) {
        return [
          {
            value: null,
            text: this.$i18n.t('general.select-industry')
          },
          ...state.industry.industries.map(industry => ({
            value: industry.id,
            text: industry[`name_${state.locale.language}`],
            icon_path: industry.icon_path
          }))
        ]
      },
    })
  },
  async created() {
    this.$store.dispatch("DevData/onGetAllDevData");
    // Google analytic page view
    Service.analytics.sendPageView({
      path: this.$route.path
    })
   await this.$store.dispatch('banner/onGetAllBanners');
  },
  methods: {
    loadMore() {
      this.isLoading = true;
      setTimeout(() => {
        Service.webdata
            .getArticles({ page: this.current_page + 1 })
            .then(res => {
              res.data.map(item => {
                this.articles.push(item);
              });

              this.activeArticles = this.articles;
              if (this.articles.length < res.total) {
                this.current_page = res.current_page;
              } else {
                this.has_more = false;
              }
            });
        this.isLoading = false;
      }, 1000);
    },
    hrefTo(path) {
      this.$router.push(path)
    },
  }
};
</script>

<style scoped>
.table-bg-color{
  color: #FF4F23!important;
  background: black !important;
}
.headTab th {
  height: 60px!important;
}
.link-data-dev-hover,.link-data-dev{
  color: black;
  font-size: 18px;
}
.link-data-dev-hover:hover{
  color: #FF4F23;
}
.dev-data-text{
  padding-left: 2%;
}
.headIndex {
  font-size: 20px;
  font-weight: bold;
}

.tableTxt {
  font-size: 17px;
  color: #fff !important;
}

th.tdHead {
  background-color: #ff5100;
  font-size: 15px;
}

/* table border style */
.theme--light.v-data-table tbody tr td {
  border-bottom: 1px solid #ff5100 !important;
}

.theme--light.v-data-table thead tr th:nth-child(even):not(:first-child) {
  color: #ff5100 !important;
}

.theme--light.v-data-table tbody tr td:not(:last-child),
.theme--light.v-data-table thead tr:last-child th:not(:last-child) {
  border-right: 1px solid #ff5100;
}
/* end table border style */

.coloredTxt {
  color: #ff5100;
}
</style>
